<template>
  <div class="login-container">
    <el-form autoComplete="on" :model="loginForm" ref="loginForm"     label-position="left" label-width="0px" class="card-box login-form">
      <div class="sign-blur"></div>
      <h3 class="title">— {{ siteName }} —</h3>
      <div class="error" v-if="errorMessage"><i class="el-icon-warning"></i><span>&nbsp;{{errorMessage}}</span></div>
      <el-form-item class="username" prop="username">
        <el-input name="username" type="text" v-model="loginForm.username" auto-complete="off" placeholder="用户名/手机号"></el-input>
      </el-form-item>
      <el-form-item class="password" prop="password">
        <el-input name="password" type="password" @keyup.enter.native="handleLogin" v-model="loginForm.password"  auto-complete="new-password" placeholder="用户密码"></el-input>
      </el-form-item>
      <el-form-item class="confirm" >
        <el-button class="confirm-btn"  type="primary" @click.native.prevent="handleLogin">登&nbsp;&nbsp;录</el-button>
      </el-form-item>
      <!-- <router-link to="/sendpwd" class="forget-pwd">忘记密码/首次登录？</router-link> -->
    </el-form>
  </div>
</template>

<script type="text/babel">
  import { mapActions } from 'vuex'
  import constants from 'config/constants'

  export default {
    data () {
      return {
        siteName: constants.basic.siteName,
        loginForm: {
          username: '',
          password: ''
        },
        errorMessage: '',
      }
    },
    methods: {
      ...mapActions([
        'login'
      ]),
      handleLogin () {
        if (!this.loginForm.username) {
          this.errorMessage = '请输入用户名'
          return
        }
        if (!this.loginForm.password) {
          this.errorMessage = '请输入密码'
          return
        }
        this.errorMessage = ''
        this.login({
          username: this.loginForm.username,
          password: this.loginForm.password
        }).then(() => {
          // console.log(this.$store.state.user.info.user_info)
          this.$router.replace({ name: 'home' })
        }).catch(err => {
          this.errorMessage = err.message
        })
      },
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .login-container
    position: relative
    width: 100%
    height: 100%
    background-color: #324157
    background-size: cover
    background-position: center
    .login-form
      position: absolute
      left: 50%
      top: 50%
      width: 400px
      height: 400px
      margin-left: -180px
      margin-top: -207px
      .sign-blur
        position: absolute
        left: 0
        right: 0
        top: 0
        bottom: 0
        background-color: rgba(38, 88, 85, .25)
        -webkit-filter: blur(0px)
        -moz-filter: blur(0px)
        -o-filter: blur(0px)
        -ms-filter: blur(0px)
        filter: blur(0px)
        border-radius: 6px
      .error
        position: absolute
        top: 110px
        left: 20px
        width:360px
        height: 32px
        line-height: 32px
        background-color: rgba(255,255,255,0.8)
        color: #ff5722
        text-align: center
        vertical-align: middle
      .title
        position: absolute
        top: 44px
        left: 60px
        height: 33px
        font-size: 24px
        font-weight: 400
        color: #ffffff
        text-align: center
        letter-spacing: 2px
      input
        background: transparent
        border: 0px
        -webkit-appearance: none
        border-radius: 0px
        padding: 12px 5px 12px 15px
        color: #eee
        height: 47px
      .el-input
        display: inline-block
        height: 40px
        width: 280px
      .username
        position: absolute
        left: 60px
        top: 140px
        border-bottom: 1px solid #ffffff
      .password
        position: absolute
        left: 60px
        top: 213px
        border-bottom: 1px solid #ffffff
      .confirm
        position: absolute
        top: 293px
        left: 60px
        .el-button
          &.confirm-btn
            width: 280px
            height: 48px
            border-radius: 5px
            font-size: 20px
            font-family: PingFang-SC-Regular MicrosoftYahei
            color: rgba(255,255,255,0.8)
      .forget-pwd
        float: right
        font-size: 12px
        color: #fff
</style>



// WEBPACK FOOTER //
// src/views/Login.vue